// Uma gravacao que falha nao pode passar despercebida. Varios botoes chamam
// `void gravarLocalEEnfileirar(...)` direto no onClick -- o `void` joga a
// rejeicao fora e a tela nao muda. Foi assim que o app inteiro ficou mudo no
// celular quando crypto.randomUUID sumiu (ver novoId.ts).
//
// Em vez de remendar cada botao, o registro mora no ponto por onde TODA
// gravacao passa. As funcoes de gravacao registram e CONTINUAM LANCANDO: quem
// ja trata o erro (DetalhePedido, AjustarItens, ConfirmarEntrega, useSalvamento)
// segue tratando.

export interface FalhaDeGravacao {
  tabela: string
  mensagem: string
  quando: string
}

let falha: FalhaDeGravacao | null = null
const ouvintes = new Set<() => void>()

function avisar(): void {
  for (const ouvinte of ouvintes) ouvinte()
}

export function registrarFalhaDeGravacao(tabela: string, erro: unknown): void {
  falha = {
    tabela,
    mensagem: erro instanceof Error ? erro.message : String(erro),
    quando: new Date().toISOString(),
  }
  avisar()
}

export function ultimaFalhaDeGravacao(): FalhaDeGravacao | null {
  return falha
}

export function limparFalhaDeGravacao(): void {
  falha = null
  avisar()
}

export function assinarFalhaDeGravacao(ouvinte: () => void): () => void {
  ouvintes.add(ouvinte)
  return () => ouvintes.delete(ouvinte)
}
